import React from 'react'
import Popup from '~shared/components/organisms/Popup/index'
import PopupBox from './PopupBox'
import PopupContent from './PopupContent'
import PopupHeader from './PopupHeader'
import Subscriber from '~shared/utils/Subscriber'
import PopupContext from './PopupContext'

class PopupWrapper extends React.Component {
  onCloseSubscriber = new Subscriber()
  popupRef = React.createRef()
  contextValue = {
    popup: true,
    listenToOuterClose: this.onCloseSubscriber.subscribe,
    popupRef: this.popupRef,
  }

  handlePopupClose = event => {
    this.onCloseSubscriber.dispatch(event)
  }

  componentWillUnmount() {
    this.onCloseSubscriber.reset()
  }

  render() {
    const {
      wrap,
      onClose,
      children,
      isOpen,
      preventCickOutside,
      componentName,
      /*minWidth,*/ maxWidth,
      /*minHeight,*/ maxHeight,
    } = this.props

    const commonProps = {
      'data-popup-id': componentName,
      open: isOpen,
      id: 'popup-wrapper',
    }

    return wrap ? (
      <Popup {...commonProps} onClose={onClose} rootRef={this.popupRef}>
        <PopupBox onClose={onClose} maxWidth={maxWidth} maxHeight={maxHeight}>
          <PopupHeader />
          <PopupContent>
            <PopupContext.Provider value={this.contextValue}>{children}</PopupContext.Provider>
          </PopupContent>
        </PopupBox>
      </Popup>
    ) : (
      <Popup
        {...commonProps}
        disableBackdropClick={preventCickOutside}
        disableEscapeKeyDown={preventCickOutside}
        onClose={this.handlePopupClose}
        rootRef={this.popupRef}
      >
        <PopupContext.Provider value={this.contextValue}>{children}</PopupContext.Provider>
      </Popup>
    )
  }
}

export default PopupWrapper
